import React,{ Component } from 'react';

import { Button } from 'reactstrap';

import TextInput from '../../../shared/components/TextInput';
import Form from '../../../shared/components/Form';
import TutorialPopover from '../../../shared/components/TutorialPopover';

class CampaignNameForm extends Component {
  constructor(){
    super();

    this.state = {
      validationMessages:{},
      isShowingPopover:false
    };
  }

  componentWillMount(){
    if(this.props.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }
  }

  handleSubmit(data){
    const validationMessages = {};

    if(!data.name || data.name.trim().length === 0){
      validationMessages['campaignName'] = 'Name is required';
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      this.props.onSubmit(data);
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit(data);
    }
  }

  render(){
    return (
      <Form 
        includeEmpty
        onSubmit={(data) => this.handleSubmit(data)}
      >
        <TutorialPopover
          open={this.state.isShowingPopover && this.props.isShowingTutorial}
          target='CampaignNameInput'
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='Experience Name'
        >
          <p>
            Your audience won't see this.
          </p>
        </TutorialPopover>
        <TextInput
          id='CampaignNameInput'
          name='name'
          defaultValue={this.props.activeCampaignName}
          placeholder='Our First Experience'
          warning={this.state.validationMessages['campaignName']}
        />
        <Button size='sm' color='primary'>
          &nbsp;&nbsp;Save&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}

CampaignNameForm.defaultProps = {
  isShowingTutorial:true
};

export default CampaignNameForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignNameForm.js